(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-curriculum"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";
    var CACHE_KEY = "gaani:catalog:v1";
    var CACHE_MS = 5 * 60 * 1000;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    }

    // One catalog fetch per visit, shared by every curriculum section on the page
    // and cached for a few minutes across pages. Follows nextCursor so a catalog
    // larger than one page still finds its course.
    var pending = null;
    function loadCatalog(proxy) {
      if (pending) { return pending; }
      try {
        var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
        if (cached && Date.now() - cached.t < CACHE_MS && Array.isArray(cached.courses)) {
          pending = Promise.resolve(cached.courses);
          return pending;
        }
      } catch (e) {}
      var all = [];
      function page(cursor, n) {
        var url = root() + proxy + "/api/catalog?limit=50" + (cursor ? "&cursor=" + encodeURIComponent(cursor) : "");
        return fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { if (!r.ok) { throw new Error("catalog " + r.status); } return r.json(); })
          .then(function (data) {
            all = all.concat((data && data.courses) || []);
            if (data && data.nextCursor && n < 10) { return page(data.nextCursor, n + 1); }
            return all;
          });
      }
      pending = page(null, 1).then(function (courses) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), courses: courses })); } catch (e) {}
        return courses;
      }, function (err) {
        // A failed fetch must not stay cached as a rejected promise: the next call
        // (another section, a theme-editor reload) gets a fresh try.
        pending = null;
        throw err;
      });
      return pending;
    }

    function duration(sec) {
      sec = Number(sec) || 0;
      if (sec <= 0) { return ""; }
      var h = Math.floor(sec / 3600);
      var m = Math.round((sec % 3600) / 60);
      if (m === 60) { h += 1; m = 0; }
      return h ? h + "h" + (m ? " " + m + "m" : "") : m + "m";
    }
    function plural(n, one, many) { return n + " " + (n === 1 ? one : many); }
    function list(v) {
      if (Array.isArray(v)) { return v; }
      if (typeof v === "string" && v.trim()) {
        try { var parsed = JSON.parse(v); if (Array.isArray(parsed)) { return parsed; } } catch (e) {}
        return v.split(/\n+/);
      }
      return [];
    }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) { n.className = cls; }
      if (text != null) { n.textContent = text; }
      return n;
    }

    function render(sectionEl, course) {
      var chapters = Array.isArray(course.chapters) ? course.chapters : [];
      if (!chapters.length) { return false; }

      var stats = [];
      var nCh = course.totalChapters || chapters.length;
      if (nCh) { stats.push(plural(nCh, "chapter", "chapters")); }
      if (course.totalLessons) { stats.push(plural(course.totalLessons, "lesson", "lessons")); }
      var d = duration(course.totalDurationSeconds);
      if (d) { stats.push(d + " of video"); }
      var statsEl = sectionEl.querySelector("[data-curr-stats]");
      if (statsEl) { statsEl.textContent = stats.join(" · "); }

      var ol = sectionEl.querySelector("[data-curr-chapters]");
      ol.textContent = "";
      chapters.forEach(function (ch, i) {
        var li = el("li", "index__row lectern-curr__row");
        li.appendChild(el("span", "index__num", String(i + 1).padStart(2, "0")));
        li.appendChild(el("span", "index__title", ch && ch.title ? String(ch.title) : ""));
        var n = Number(ch && ch.lessons) || 0;
        li.appendChild(el("span", "index__dur", n ? plural(n, "lesson", "lessons") : ""));
        ol.appendChild(li);
      });

      var learn = list(course.whatYouLearn).map(function (s) { return String(s).replace(/^[\s•\-–—*]+/, "").trim(); }).filter(Boolean);
      var learnWrap = sectionEl.querySelector("[data-curr-learn-wrap]");
      var ul = sectionEl.querySelector("[data-curr-learn]");
      if (learnWrap && ul && learn.length) {
        ul.textContent = "";
        learn.forEach(function (t) { ul.appendChild(el("li", null, t)); });
        learnWrap.hidden = false;
      }

      var pv = sectionEl.querySelector("[data-curr-preview]");
      var pvWrap = sectionEl.querySelector("[data-curr-preview-wrap]");
      if (pv && pvWrap && course.id) {
        pv.href = root() + sectionEl.getAttribute("data-proxy") + "/" + encodeURIComponent(course.id);
        pvWrap.hidden = false;
      }
      return true;
    }

    function init() {
      document.querySelectorAll("[data-curriculum]").forEach(function (sectionEl) {
        if (sectionEl.dataset.currBound) { return; }
        sectionEl.dataset.currBound = "1";
        var handle = sectionEl.getAttribute("data-handle");
        // Tolerate "/apps/courses/" as typed in the editor: no leading/trailing slash.
        var proxy = (sectionEl.getAttribute("data-proxy") || "apps/courses").replace(/^\/+|\/+$/g, "") || "apps/courses";
        sectionEl.setAttribute("data-proxy", proxy);
        if (!handle || !window.fetch) { return; }
        loadCatalog(proxy)
          .then(function (courses) {
            var course = null;
            courses.forEach(function (c) { if (c && c.productHandle === handle) { course = c; } });
            if (course && render(sectionEl, course)) { sectionEl.hidden = false; }
          })
          .catch(function () { /* stays hidden */ });
      });
    }

    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
    else { init(); }
    if (window.Shopify && window.Shopify.designMode) { document.addEventListener("shopify:section:load", init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";

    function initForm(section) {
      var form = section.querySelector("[data-product-form]");
      var dataEl = section.querySelector("[data-variant-data]");
      if (!form || !dataEl) { initRecipient(section); return; }

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!variants || !variants.length) { initRecipient(section); return; }

      // Ensure a submittable id input exists (radios drive it; no-JS uses the <noscript> select).
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = "id";
        form.appendChild(idInput);
      }

      var radios = form.querySelectorAll("input[data-option-position]");
      var addBtn = form.querySelector("[data-add-btn]");
      var priceNow = section.querySelector("[data-price-current]");
      var priceWas = section.querySelector("[data-price-compare]");
      var unitEl = section.querySelector("[data-unit-price]");
      var stage = section.querySelector("[data-product-media]");

      function selectedOptions() {
        var opts = [];
        form.querySelectorAll("[data-variant-radios] [data-option-position]:checked").forEach(function (r) {
          opts[parseInt(r.getAttribute("data-option-position"), 10) - 1] = r.value;
        });
        return opts;
      }

      function findVariant() {
        if (!radios.length) { return variants[0]; }
        var sel = selectedOptions();
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < variants[i].options.length; j++) {
            if (variants[i].options[j] !== sel[j]) { match = false; break; }
          }
          if (match) { return variants[i]; }
        }
        return null;
      }

      function swapMedia(mediaId) {
        if (!stage || !mediaId) { return; }
        var items = stage.querySelectorAll("[data-media-id]");
        var found = false;
        items.forEach(function (it) {
          var on = it.getAttribute("data-media-id") === String(mediaId);
          it.hidden = !on;
          it.classList.toggle("is-active", on);
          if (on) { found = true; }
        });
        if (!found) { return; }
        stage.querySelectorAll("[data-media-target]").forEach(function (t) {
          var on = t.getAttribute("data-media-target") === String(mediaId);
          t.classList.toggle("is-active", on);
          if (on) { t.setAttribute("aria-current", "true"); } else { t.removeAttribute("aria-current"); }
        });
      }

      function render(v) {
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute("data-label-unavailable"); }
          document.querySelectorAll("[data-variant-addbtn-sync]").forEach(function (el) {
            el.disabled = true;
            el.textContent = el.getAttribute("data-label-unavailable") || el.getAttribute("data-label-soldout") || el.textContent;
          });
          document.querySelectorAll("[data-variant-price-sync]").forEach(function (el) { el.textContent = ""; });
          // Clear the stale variant id so no wrong id lingers in the sticky bar's hidden input.
          document.querySelectorAll("[data-variant-id-input]").forEach(function (el) { el.value = ""; });
          return;
        }
        idInput.value = v.id;
        if (priceNow) { priceNow.innerHTML = v.price; }
        if (priceWas) {
          if (v.compare_at) { priceWas.innerHTML = v.compare_at; priceWas.hidden = false; }
          else { priceWas.hidden = true; priceWas.textContent = ""; }
        }
        if (unitEl) {
          if (v.unit) {
            var ref = (v.unit_ref && v.unit_ref !== 1) ? (v.unit_ref + " ") : "";
            unitEl.textContent = v.unit + "/" + ref + (v.unit_unit || "");
            unitEl.hidden = false;
          } else { unitEl.hidden = true; unitEl.textContent = ""; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.getAttribute("data-label-add") : addBtn.getAttribute("data-label-soldout");
        }
        swapMedia(v.media_id);
        // Keep a sticky enroll bar (separate section) in sync.
        document.querySelectorAll("[data-variant-id-input]").forEach(function (el) { el.value = v.id; });
        document.querySelectorAll("[data-variant-price-sync]").forEach(function (el) { el.innerHTML = v.price; });
        document.querySelectorAll("[data-variant-addbtn-sync]").forEach(function (el) {
          el.disabled = !v.available;
          el.textContent = v.available ? el.getAttribute("data-label-add") : el.getAttribute("data-label-soldout");
        });
      }

      radios.forEach(function (r) { r.addEventListener("change", function () { render(findVariant()); }); });

      if (stage) {
        stage.querySelectorAll("[data-media-target]").forEach(function (t) {
          t.addEventListener("click", function () { swapMedia(t.getAttribute("data-media-target")); });
        });
      }

      render(findVariant());
      initRecipient(section);
    }

    function initRecipient(section) {
      var wrap = section.querySelector("[data-recipient]");
      if (!wrap) { return; }
      var toggle = wrap.querySelector("[data-recipient-toggle]");
      var fields = wrap.querySelector("[data-recipient-fields]");
      var control = wrap.querySelector("[data-recipient-control]");
      var offset = wrap.querySelector("[data-recipient-offset]");
      if (!toggle || !fields) { return; }
      toggle.addEventListener("change", function () {
        var on = toggle.checked;
        fields.hidden = !on;
        if (control) { control.disabled = !on; control.value = on ? "true" : ""; }
        if (offset) { offset.disabled = !on; offset.value = on ? String(new Date().getTimezoneOffset()) : ""; }
        fields.querySelectorAll("input, textarea").forEach(function (el) {
          if (el === control || el === offset) { return; }
          el.disabled = !on;
        });
      });
    }

    function init() {
      document.querySelectorAll("[data-product-section]").forEach(initForm);
    }
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
    else { init(); }
    if (window.Shopify && Shopify.designMode) { document.addEventListener("shopify:section:load", init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var f = document.querySelector(".lectern-footer");
      if (!f || f.dataset.liveBound || !("IntersectionObserver" in window)) { return; }
      f.dataset.liveBound = "1";
      new IntersectionObserver(function (entries) {
        f.classList.toggle("lectern-footer--live", entries[0].isIntersecting);
      }).observe(f);
    }
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
    if (window.Shopify && window.Shopify.designMode) { document.addEventListener("shopify:section:load", init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    "use strict";
    var docWired = false;
    var geoDocWired = false;
    var ccyWired = false;

    // Back/forward navigation re-applies the value the visitor had selected before
    // submitting, which leaves the chip's server-rendered face and its select
    // disagreeing — and picking that same country again would then fire no change
    // event at all, so the control would look dead. Restore the server's answer.
    function initCcy() {
      if (ccyWired) { return; }
      ccyWired = true;
      window.addEventListener("pageshow", function () {
        document.querySelectorAll(".lectern-header [data-localization-select]").forEach(function (sel) {
          var def = sel.querySelector("option[selected]");
          if (def && sel.value !== def.value) { sel.value = def.value; }
        });
      });
    }

    // Currency suggestion strip. Asks Shopify which market fits this visitor and,
    // if it is not the one they are browsing, offers the switch. Suggest only —
    // never redirect, never assert where the visitor is.
    function initGeo() {
      var el = document.querySelector("[data-geo]");
      if (!el || el.dataset.geoBound) { return; }
      el.dataset.geoBound = "1";
      var src = document.getElementById("HeaderCountry");
      var codeInput = el.querySelector("[data-geo-code]");
      var toEl = el.querySelector("[data-geo-to]");
      var closeBtn = el.querySelector("[data-geo-close]");
      if (!src || !codeInput || !toEl || !closeBtn) { return; }

      var KEY = "gaani:geo:v1";
      var SEEN = "gaani:geo:seen";
      var here = (el.getAttribute("data-geo-current") || "").toUpperCase();
      var from = (el.getAttribute("data-geo-from") || "").trim();
      var design = !!(window.Shopify && window.Shopify.designMode);

      function show(iso) {
        // iso arrives off the network, so validate before it reaches a selector.
        if (!/^[A-Za-z]{2}$/.test(iso)) { return; }
        // In the page flow, not over it: the top of <main>, above the hero.
        var mainEl = document.getElementById("MainContent");
        if (mainEl && el.parentNode !== mainEl) { mainEl.insertBefore(el, mainEl.firstChild); }
        var opt = src.querySelector('option[value="' + iso.toUpperCase() + '"]');
        if (!opt) { return; }
        var label = ((opt.getAttribute("data-cur") || "") + " " + (opt.getAttribute("data-sym") || "")).trim();
        // Different country, same currency — nothing worth interrupting anyone for.
        if (!label || label === from) { return; }
        codeInput.value = opt.value;
        toEl.textContent = label;
        el.hidden = false;
        el.getBoundingClientRect(); // flush the display change so the transition runs
        el.classList.add("is-in");
      }
      function hide() {
        // Hiding the element the visitor is standing on would drop focus to <body>
        // and lose their place, so hand it to <main> (tabindex="-1" in theme.liquid).
        var hadFocus = el.contains(document.activeElement);
        el.classList.remove("is-in");
        el.hidden = true;
        if (hadFocus) {
          var main = document.getElementById("MainContent");
          if (main) { main.focus({ preventScroll: true }); }
        }
      }

      closeBtn.addEventListener("click", function () {
        hide();
        if (!design) { try { localStorage.setItem(KEY, codeInput.value); } catch (e) {} }
      });

      if (design) {
        if (el.getAttribute("data-geo-preview") === "true") {
          for (var i = 0; i < src.options.length; i++) {
            // Keep scanning: show() bails on a country that shares the current currency.
            if (src.options[i].value !== src.value) {
              show(src.options[i].value);
              if (!el.hidden) { break; }
            }
          }
        }
        return;
      }

      // Picking a country anywhere — chip, drawer or footer — is a stated
      // preference, so stop suggesting. Capture phase, because lectern.js
      // submits the form on this same event.
      if (!geoDocWired) {
        geoDocWired = true;
        document.addEventListener("change", function (e) {
          // Country only. The footer's language select carries the same attribute,
          // and changing a language says nothing about which currency you want.
          var t = e.target;
          if (t && t.matches && t.matches('select[name="country_code"][data-localization-select]')) {
            try { localStorage.setItem(KEY, "*"); } catch (err) {}
          }
        }, true);
      }

      try { if (sessionStorage.getItem(SEEN)) { return; } } catch (e) {}
      var stored = null;
      try { stored = localStorage.getItem(KEY); } catch (e) {}
      if (stored === "*") { return; }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "browsing_context_suggestions.json?country[enabled]=true&country[exclude]=" + encodeURIComponent(here))
        .then(function (r) { if (!r.ok) { throw new Error("http " + r.status); } return r.json(); })
        .then(function (data) {
          // Asked and answered for this visit — including the common case where the
          // visitor is already in the right market and there is nothing to suggest.
          // Only a failed request (see .catch) is worth retrying on the next page.
          try { sessionStorage.setItem(SEEN, "1"); } catch (e) {}
          var first = data && Array.isArray(data.suggestions) ? data.suggestions[0] : null;
          var part = first && first.parts && first.parts.country;
          if (!part || !part.handle) { return; }
          var iso = String(part.handle).toUpperCase();
          if (iso === here || iso === stored) { return; }
          // Already reading the page — a slow lookup does not get to interrupt them.
          if (window.scrollY > 120) { return; }
          show(iso);
          // In the flow it simply scrolls away with the page; hiding it mid-scroll
          // would yank the content up under the reader.
        })
        .catch(function () {});
    }

    // Predictive search is an ARIA 1.2 combobox: DOM focus stays in the input and
    // the arrow keys move a virtual cursor through the role="option" links that
    // the predictive-search section renders, exposed via aria-activedescendant.
    // The active option is read from the DOM (aria-selected), not kept in a
    // variable, so the document-wide handlers below can collapse it as well.
    function searchOptions(p) {
      return Array.prototype.slice.call(p.querySelectorAll('[data-predictive-results] [role="option"]'));
    }
    function activeIndex(opts) {
      for (var i = 0; i < opts.length; i++) { if (opts[i].getAttribute("aria-selected") === "true") { return i; } }
      return -1;
    }
    function setActive(input, opts, i) {
      var was = activeIndex(opts);
      if (was > -1) { opts[was].setAttribute("aria-selected", "false"); }
      if (i < 0 || !opts[i]) { input.removeAttribute("aria-activedescendant"); return; }
      opts[i].setAttribute("aria-selected", "true");
      input.setAttribute("aria-activedescendant", opts[i].id);
      opts[i].scrollIntoView({ block: "nearest" });
    }
    // Show or hide the popup. aria-expanded is only "true" while a listbox is
    // actually on screen; the "no matches" note is visible but is not a listbox.
    function setExpanded(p, on) {
      var input = p.querySelector("[data-predictive-input]");
      var results = p.querySelector("[data-predictive-results]");
      if (!input || !results) { return; }
      results.hidden = !on;
      var listed = !!on && !!results.querySelector('[role="listbox"]');
      input.setAttribute("aria-expanded", listed ? "true" : "false");
      if (!listed) { setActive(input, searchOptions(p), -1); }
    }

    function init() {
      initCcy();
      initGeo();
      var toggle = document.querySelector("[data-search-toggle]");
      var panel = document.getElementById("SearchPanel");
      if (!toggle || !panel) { return; }
      var input = panel.querySelector("[data-predictive-input]");
      var results = panel.querySelector("[data-predictive-results]");
      var status = panel.querySelector("[data-predictive-status]");
      var closeBtn = panel.querySelector("[data-search-close]");
      var url = panel.getAttribute("data-predictive-url");
      var timer, controller;

      function open() {
        panel.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        if (input && results) {
          // Re-show the last suggestions only if they still belong to the text in
          // the field — Escape on type=search can empty it without an input event.
          if (results.innerHTML.trim() && results.getAttribute("data-term") === input.value.trim()) { setExpanded(panel, true); }
          else { results.innerHTML = ""; setExpanded(panel, false); if (status) { status.textContent = ""; } }
          input.focus();
        }
      }
      // A search queued by the 250ms debounce or already in flight must not come back
      // and reopen suggestions the visitor just dismissed.
      function cancelPending() { clearTimeout(timer); if (controller) { controller.abort(); controller = null; } }
      function close() { cancelPending(); panel.hidden = true; toggle.setAttribute("aria-expanded", "false"); setExpanded(panel, false); }

      // init() re-runs on every theme-editor section load; without this guard each
      // reload of ANY section stacked another click handler, so one click opened
      // and immediately closed the panel.
      if (toggle.dataset.searchBound) { return; }
      toggle.dataset.searchBound = "1";

      toggle.addEventListener("click", function () { if (panel.hidden) { open(); } else { close(); } });
      if (closeBtn) { closeBtn.addEventListener("click", function () { close(); toggle.focus(); }); }

      if (!docWired) {
        docWired = true;
        document.addEventListener("keydown", function (e) {
          var p = document.getElementById("SearchPanel");
          var t = document.querySelector("[data-search-toggle]");
          if (!p || !t) { return; }
          // defaultPrevented: the input's own Escape already closed the suggestions;
          // the next Escape closes the panel.
          if (e.key === "Escape" && !e.defaultPrevented && !p.hidden) { p.hidden = true; t.setAttribute("aria-expanded", "false"); setExpanded(p, false); t.focus(); }
        });
        document.addEventListener("click", function (e) {
          var p = document.getElementById("SearchPanel");
          var t = document.querySelector("[data-search-toggle]");
          if (!p || !t) { return; }
          if (!p.hidden && !p.contains(e.target) && !t.contains(e.target)) { p.hidden = true; t.setAttribute("aria-expanded", "false"); setExpanded(p, false); }
        });
      }

      if (!input || !url || !results) { return; }

      function render(html, message, term) {
        results.innerHTML = html;
        results.setAttribute("data-term", html ? term : "");
        setExpanded(panel, html !== "");
        if (status) { status.textContent = message; }
      }

      input.addEventListener("input", function () {
        var term = input.value.trim();
        clearTimeout(timer);
        setActive(input, searchOptions(panel), -1);
        if (term.length < 2) {
          if (controller) { controller.abort(); }
          render("", "");
          return;
        }
        timer = setTimeout(function () { run(term); }, 250);
      });

      input.addEventListener("keydown", function (e) {
        if (e.isComposing) { return; }
        var opts = searchOptions(panel);
        var expanded = input.getAttribute("aria-expanded") === "true";
        var i = activeIndex(opts);
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          if (!opts.length) { return; }
          e.preventDefault();
          var down = e.key === "ArrowDown";
          if (!expanded) { setExpanded(panel, true); setActive(input, opts, down ? 0 : opts.length - 1); return; }
          setActive(input, opts, down ? (i + 1) % opts.length : (i < 1 ? opts.length - 1 : i - 1));
        } else if (e.key === "Enter") {
          // With no active option Enter submits the form: the full results page.
          if (expanded && i > -1) { e.preventDefault(); opts[i].click(); }
        } else if (e.key === "Escape") {
          // First Escape closes the suggestions and keeps the text (preventDefault
          // also stops the browser clearing type=search); the next closes the panel.
          // Either way, drop the pending search so it can't reopen them.
          cancelPending();
          if (!results.hidden && results.innerHTML.trim()) { e.preventDefault(); setExpanded(panel, false); }
        }
      });

      function run(term) {
        if (controller) { controller.abort(); }
        controller = new AbortController();
        var q = url + "?q=" + encodeURIComponent(term) + "&section_id=predictive-search&resources[type]=query,product,collection,article,page&resources[limit]=6";
        fetch(q, { signal: controller.signal })
          .then(function (r) { if (!r.ok) { throw new Error("http " + r.status); } return r.text(); })
          .then(function (text) {
            if (input.value.trim() !== term) { return; } // the visitor has typed on since
            if (panel.hidden) { return; } // closed by Escape or an outside click meanwhile
            var doc = new DOMParser().parseFromString(text, "text/html");
            var content = doc.querySelector("[data-predictive-content]");
            var message = doc.querySelector("[data-predictive-message]");
            render(content ? content.innerHTML.trim() : "", message ? message.textContent.trim() : "", term);
          })
          .catch(function () {});
      }
    }
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
    else { init(); }
    if (window.Shopify && Shopify.designMode) { document.addEventListener("shopify:section:load", init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind() {
    document.querySelectorAll('[data-share]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var btn = box.querySelector('[data-share-btn]');
      var status = box.querySelector('[data-share-status]');
      if (!btn) return;
      var url = box.dataset.url, title = box.dataset.title, timer;
      if (navigator.share) {
        btn.textContent = btn.dataset.shareLabel;
        btn.hidden = false;
        btn.addEventListener('click', function () {
          navigator.share({ title: title, url: url }).catch(function () {});
        });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        btn.textContent = btn.dataset.copyLabel;
        btn.hidden = false;
        btn.addEventListener('click', function () {
          navigator.clipboard.writeText(url).then(function () {
            status.textContent = btn.dataset.copiedLabel;
            btn.textContent = btn.dataset.copiedLabel;
            clearTimeout(timer);
            timer = setTimeout(function () {
              btn.textContent = btn.dataset.copyLabel;
              status.textContent = '';
            }, 2000);
          }).catch(function () {});
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  function centreChip() {
    document.querySelectorAll('[data-qa-chips]').forEach(function (row) {
      var chip = row.querySelector('[aria-current="page"]');
      if (chip) row.scrollLeft = chip.offsetLeft - row.offsetLeft - 16;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', centreChip);
  else centreChip();
  document.addEventListener('shopify:section:load', centreChip);
  // Keyboard focus: bring a part-hidden chip fully into the scroll row (browsers leave it clipped).
  // Lands on the chip's snap position, so scroll-snap does not pull it back.
  if (!window.__sgChipFocus) {
    window.__sgChipFocus = true;
    document.addEventListener('focusin', function (e) {
      var chip = e.target.closest ? e.target.closest('.sg-chip') : null;
      var row = chip && chip.closest('[data-qa-chips]');
      if (!row || row.scrollWidth <= row.clientWidth) return;
      var cs = getComputedStyle(row), r = row.getBoundingClientRect(), c = chip.getBoundingClientRect();
      var left = r.left + (parseFloat(cs.paddingLeft) || 0), right = r.right - (parseFloat(cs.paddingRight) || 0);
      if (c.left < left - 0.5 || c.right > right + 0.5) row.scrollLeft += c.left - left;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";
    function load(node) {
      var url = node.getAttribute("data-reco-url");
      var sectionEl = node.closest(".lectern-reco");
      if (!url || !sectionEl) { return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, "text/html");
          var fresh = doc.querySelector(".lectern-reco");
          if (fresh) {
            // Injected cards miss the initial IntersectionObserver, so reveal them directly.
            fresh.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-in"); });
            sectionEl.replaceWith(fresh);
          }
        })
        .catch(function () {});
    }
    function init() { document.querySelectorAll("[data-reco]").forEach(load); }
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
    else { init(); }
    if (window.Shopify && Shopify.designMode) { document.addEventListener("shopify:section:load", init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-follow"] && !Shopify.designMode) return;
  try {
    
  /* Load TikTok's script only once the block is close to the viewport, and only
     once per page. Scrolling past cheaply is the common case; paying for a
     third-party script up front is not. */
  (function () {
    var SRC = 'https://www.tiktok.com/embed.js';
    var loaded = false;

    function load() {
      if (loaded || document.querySelector('script[src="' + SRC + '"]')) return;
      loaded = true;
      var s = document.createElement('script');
      s.async = true;
      s.src = SRC;
      document.body.appendChild(s);
    }

    /* TikTok rate-limits embeds. When it does, its script REPLACES our markup
       with raw text ("overload-protect triggered") — developer output sitting on
       a sales page, with no fallback of its own. If no iframe has appeared after
       a grace period, take the block back and show a plain branded link. */
    function guard(el) {
      setTimeout(function () {
        if (el.querySelector('iframe')) return;
        var label = el.getAttribute('data-tok-fallback') || 'See more on TikTok';
        var href = el.getAttribute('data-tok-profile') || 'https://www.tiktok.com/';
        el.classList.add('sg-follow__embed--fallback');
        el.textContent = '';
        var a = document.createElement('a');
        a.className = 'btn btn--ghost';
        a.href = href; a.target = '_blank'; a.rel = 'noopener noreferrer';
        a.textContent = label;
        el.appendChild(a);
      }, 8000);
    }

    function watch(el) {
      if (!('IntersectionObserver' in window)) { load(); guard(el); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { load(); guard(el); io.disconnect(); }
        });
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    }

    function init() {
      var blocks = document.querySelectorAll('[data-tok-embed]');
      for (var i = 0; i < blocks.length; i++) watch(blocks[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    /* Theme editor re-renders sections without a page load. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
